import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronLeft, ChevronRight, Star } from "lucide-react";
import { EASE, Eyebrow } from "./Reveal";

const TESTIMONIALS = [
  {
    name: "Neil R",
    occasion: "Stag Party, 22 Guests",
    text: "Absolutely brilliant craic. We had a stag party with 22 brave souls on the island. The Lodge was really well equipped for a big group and Ciaran was happy for us to bring a gas BBQ for the weekend \u2014 he was incredibly accommodating and I felt well assured that the group were in good hands for the activities we booked in. Would highly recommend the island for any occasion, a really great place to spend some time.",
  },
  {
    name: "Claire B",
    occasion: "School Tours",
    text: "Fantastic. I've taken two school groups here this year and I couldn't recommend this place highly enough. Ciaran is terrific and couldn't do enough for us\u2026 very professional in regards to safety but allowed the students have great fun. We'll be back!",
  },
  {
    name: "Michelle G",
    occasion: "30th Birthday Weekend",
    text: "The best weekend!! Stayed here for 2 nights for my 30th birthday in June. Couldn't have asked for a better weekend. My friends and family all had the best weekend and will remember it forever. We also booked kayaking which was such a good laugh! Ciaran was a pleasure to deal with and we cannot wait to go back!!",
  },
  {
    name: "Marie G",
    occasion: "Group of Friends",
    text: "A must visit for everyone. We visited Collanmore a few weeks ago as a group of friends. I could not recommend it highly enough \u2014 from start to finish we had a ball. Ciaran made everything, from booking to dropping us back to the pier, so special and memorable. We are already planning our next trip.",
  },
];

export default function Testimonials() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIndex((i) => (i + 1) % TESTIMONIALS.length), 7000);
    return () => clearInterval(t);
  }, [index]);

  const go = (dir) => setIndex((i) => (i + dir + TESTIMONIALS.length) % TESTIMONIALS.length);
  const t = TESTIMONIALS[index];

  return (
    <section className="bg-navy-800 py-24 lg:py-32">
      <div className="mx-auto max-w-5xl px-5 text-center sm:px-8">
        <Eyebrow center>What People Say</Eyebrow>

        <div className="mt-8 flex items-center justify-center gap-1.5" aria-label="Five star reviews">
          {Array.from({ length: 5 }).map((_, i) => (
            <Star key={i} className="h-4 w-4 fill-gold text-gold" />
          ))}
        </div>

        <div className="relative mt-10 min-h-[260px] sm:min-h-[240px]" data-testid="testimonial-carousel">
          <AnimatePresence mode="wait">
            <motion.blockquote
              key={index}
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -16 }}
              transition={{ duration: 0.7, ease: EASE }}
            >
              <p className="mx-auto max-w-4xl font-serif text-2xl font-light italic leading-snug text-ivory sm:text-3xl lg:text-[2.6rem] lg:leading-[1.25]">
                &ldquo;{t.text}&rdquo;
              </p>
              <footer className="mt-8">
                <p className="text-[12px] font-semibold uppercase tracking-[0.26em] text-gold">
                  {t.name}
                </p>
                <p className="mt-1 text-[11px] uppercase tracking-[0.2em] text-mist">{t.occasion}</p>
              </footer>
            </motion.blockquote>
          </AnimatePresence>
        </div>

        <div className="mt-10 flex items-center justify-center gap-6">
          <button
            onClick={() => go(-1)}
            data-testid="testimonial-prev"
            aria-label="Previous review"
            className="border border-gold/30 p-3 text-gold transition-colors duration-300 hover:bg-gold-muted"
          >
            <ChevronLeft className="h-4 w-4" />
          </button>
          <div className="flex items-center gap-2.5">
            {TESTIMONIALS.map((item, i) => (
              <button
                key={item.name}
                onClick={() => setIndex(i)}
                data-testid={`testimonial-dot-${i + 1}`}
                aria-label={`Review ${i + 1}`}
                className={`h-1.5 rotate-45 transition-all duration-300 ${
                  i === index ? "w-4 bg-gold" : "w-1.5 bg-ivory/30 hover:bg-ivory/60"
                }`}
              />
            ))}
          </div>
          <button
            onClick={() => go(1)}
            data-testid="testimonial-next"
            aria-label="Next review"
            className="border border-gold/30 p-3 text-gold transition-colors duration-300 hover:bg-gold-muted"
          >
            <ChevronRight className="h-4 w-4" />
          </button>
        </div>
      </div>
    </section>
  );
}
